module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/General/Other1-65775f7ac2a195b78eb23bb55c257c97.svg";